const RoundButton = (props) => {
    //title
    //onClick
    //icon
    return <button style={{ ...props.style ?? { margin: "0px 2px 2px 2px" }, boxShadow: "none" }} type="button" title={props.title} onClick={props.onClick} className={`btn btn-default bg-${props.btnColor} btn-circle btn-my`} >
        <i className={`fa fa-${props.icon ?? 'plus'} fa-fw img-circle`} style={props.color ?? { color: props.iconColor }} ></i>
    </button>
}

export default RoundButton;